import { render, staticRenderFns } from "./CategoryCustomFieldsModal.vue?vue&type=template&id=0cb835e2&scoped=true"
import script from "./CategoryCustomFieldsModal.vue?vue&type=script&lang=ts"
export * from "./CategoryCustomFieldsModal.vue?vue&type=script&lang=ts"
import style0 from "./CategoryCustomFieldsModal.vue?vue&type=style&index=0&id=0cb835e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb835e2",
  null
  
)

export default component.exports